import { Routes, Route, BrowserRouter } from "react-router-dom";
import Inicio from "../pages/Inicio";
import Contact from "../pages/Contact/Contact";
import Specialties from "../pages/Specialties";
import CourseDetails from "../pages/CourseDetails";
import CoursesPage from "../pages/CoursesPage/CoursesPage";
import AboutUsPage from "../pages/AboutUs/AboutUsPage";
import CoursePaymentPage from "../pages/CoursePaymentPage/CoursePaymentPage";
import PaymentCheckout from "../pages/PaymentCheckout/PaymentCheckout";
import TransferBankPage from "../pages/TransferBankPage/TransferBankPage";
import { ScrollToTop } from 'react-router-scroll-to-top';
import Error404Page from "../pages/ErrorPage/Error404Page";
import PreguntasFrecuentes from "../pages/PreguntasFrecuentes/PreguntasFrecuentes";
import Registry from "../pages/Campus/Registry";
import Admin from "../pages/Admin/Admin";
import EliteOffer from "../pages/EliteOffer/EliteOffer";
import BlogPage from "../pages/Blog/BlogPage";
import BlogDetails from "../pages/BlogDetails/BlogDetails";
import Catalog from "../pages/Catalog/Catalog";
import Subscription from "../pages/Subscription/Subscription";
import GrandPage from "../pages/Grand/GrandPage";
import Sorteo from "../pages/Sorteo/Sorteo";
import { ROUTES_PATHNAME } from "./dict";
import PersonPage from "../pages/PersonPage/PersonPage";
import TermsAndConditionsPage from "../pages/TermsAndConditionsPage/TermsAndConditionsPage";
import MainLayout from "../layouts/MainLayout/MainLayout";
import InteractiveMapAndChart from "../features/Inicio/InteractiveMapAndChart/InteractiveMapAndChart";
import {MantineProvider} from '@mantine/core';
import CancelSubscription from "../pages/CancelSubscription/CancelSubscription";
import { kioskTheme } from "../theme/kioskTheme";
import { Attractor } from "../components/Kiosk/AttractorScreen";
import { CheckIn } from "../components/Kiosk/CheckInScreen";
import { Ficha } from "../components/Kiosk/FichaScreen";
import { CaravanaScreen } from "../components/Kiosk/CaravanaScreen";
import { ArmarTablet } from "../components/Kiosk/ArmarTablet";
import { SpinScreen } from "../components/Kiosk/SpinScreen";
import { PrizeScreen } from "../components/Kiosk/PrizeScreen";
import { EntregaScreen } from "../components/Kiosk/EntregaScreen";
import { EncuentroScreen } from "../components/Kiosk/EncuentroScreen";
import { StandGate } from "../components/Kiosk/StandGate";
import { GemeloPage } from "../components/Kiosk/GemeloPage";
import { CvdlAdmin } from "../components/Kiosk/CvdlAdmin";
import { KioskLayout } from "../components/Kiosk/KioskLayout";
import  {KioskProvider} from '../context/KioskContext/KioskContext';
import { RequireAttendee } from "../components/Kiosk/KioskAttendee";

const AppRoutes = () => {
   return (
      <>
         <BrowserRouter>
            <ScrollToTop />
            <Routes>

               <Route exact path="/" element={<Inicio />} />
               <Route exact path="/mapa" element={
                  <MainLayout>
                     <InteractiveMapAndChart padding={`0 32px`} />
                  </MainLayout>
               }
               />
               <Route exact path="/catalogo" element={<Catalog />} />
               <Route path="/institucional" element={<AboutUsPage />} />
               <Route path="/contacto" element={<Contact />} />
               <Route
                  path="/especializaciones/:specialtyId"
                  element={<Specialties />}
               />
               <Route path={ROUTES_PATHNAME.courses.href} element={<CoursesPage />} />
               <Route path={`${ROUTES_PATHNAME.courses.href}/:id`} element={<CourseDetails />} />
               <Route path={'/cursos'} element={<CoursesPage />} />
               <Route path={`/curso/:id`} element={<CourseDetails />} />


               <Route path="/procesando-pago/" element={<PaymentCheckout />} />
               <Route path="/pago" element={<CoursePaymentPage />} />
               <Route path="/preguntas-frecuentes" element={<PreguntasFrecuentes />} />

               <Route path="/transferencia-bancaria" element={<TransferBankPage />} />

               <Route path="/campus" element={<Registry />} />
               <Route path="/admin" element={<Admin />} />
               <Route path="/oferta-elite" element={<EliteOffer />} />
               <Route path="/comunidad" element={<Subscription />} />

               <Route path="/desactivar" element={<CancelSubscription />} />

               <Route path="/profesores/:name" element={<PersonPage />} />

               <Route path="/sorteo/:slug" element={<Sorteo />} />
               <Route path="/terminos-y-condiciones" element={<TermsAndConditionsPage />} />

               <Route path="/grand" element={<GrandPage />} />
               <Route path={`/grand${ROUTES_PATHNAME.courses.href}/:id`} element={<CourseDetails isGrand />} />
               <Route path="/grand/curso/:id" element={<CourseDetails isGrand />} />

               <Route exact path="/grand/catalogo" element={<Catalog isGrand />} />


               <Route path="/grand/pago" element={<CoursePaymentPage isGrand />} />
               <Route path="/grand/transferencia-bancaria" element={<TransferBankPage isGrand />} />

               <Route path="/blog" element={<BlogPage />} />
               <Route path="/blog/:slugName" element={<BlogDetails />} />
               <Route
                  path="/kiosk"
                  element={
                     <MantineProvider theme={kioskTheme} defaultColorScheme="light">
                        <KioskProvider flujo="RULETA"><KioskLayout /></KioskProvider>
                     </MantineProvider>
                  }
               >
                  <Route index element={<Attractor />} />
                  <Route path="checkin" element={<CheckIn />} />
                  <Route path="ficha" element={<Ficha />} />
                  {/* Paso de caravana dentro del flujo de la ruleta. Se saltea
                      solo si la tablet no está armada, si la persona ya tiene
                      caravana o si no hay bolsa activa. */}
                  <Route path="caravana" element={<RequireAttendee><CaravanaScreen /></RequireAttendee>} />
                  {/* Se usa una vez, al montar las tablets. */}
                  <Route path="armar" element={<ArmarTablet />} />
                  <Route path="spin" element={<RequireAttendee><SpinScreen /></RequireAttendee>} />
                  <Route path="premio" element={<RequireAttendee><PrizeScreen /></RequireAttendee>} />
               </Route>
               {/* Tablet de entrega de caravanas (gemelos §5.1). Comparte
                   check-in y ficha con la ruleta; cambia solo el final. */}
               <Route
                  path="/entrega"
                  element={
                     <MantineProvider theme={kioskTheme} defaultColorScheme="light">
                        <StandGate><KioskProvider flujo="ENTREGA"><KioskLayout /></KioskProvider></StandGate>
                     </MantineProvider>
                  }
               >
                  <Route index element={<CheckIn />} />
                  <Route path="ficha" element={<Ficha />} />
                  <Route path="caravana" element={<RequireAttendee><EntregaScreen /></RequireAttendee>} />
               </Route>

               {/* Pantalla de encuentro (gemelos §5.3). No pasa por el
                   check-in: se identifica por el número de la caravana. */}
               <Route
                  path="/encuentro"
                  element={
                     <MantineProvider theme={kioskTheme} defaultColorScheme="light">
                        <StandGate>
                           <KioskProvider flujo="ENTREGA"><KioskLayout /></KioskProvider>
                        </StandGate>
                     </MantineProvider>
                  }
               >
                  <Route index element={<EncuentroScreen />} />
               </Route>

               {/* Página pública de gemelos (§5.2). Es a donde apunta el QR
                   impreso en las 400 cintas: sin login y a una mano. */}
               <Route path="/gemelo" element={
                  <MantineProvider theme={kioskTheme} defaultColorScheme="light">
                     <GemeloPage />
                  </MantineProvider>} />

               {/* Tablero de dirección (ruleta §8.6 y gemelos §5.5). Entra
                   con PIN propio: no cuelga del panel admin existente. */}
               <Route path="/admin/cvdl" element={
                  <MantineProvider theme={kioskTheme} defaultColorScheme="light">
                     <CvdlAdmin />
                  </MantineProvider>} />

               <Route path="*" element={<Error404Page />} />

            </Routes>
         </BrowserRouter>
      </>
   );
};
export default AppRoutes;
